// extracted by mini-css-extract-plugin
export default {"root":"BrandPlaceholder_root__xy+Fo","initials":"BrandPlaceholder_initials__ySiqG"};